import moment from 'moment';

function escapeHtml(s) {
    if (s == null || s === '') return '';
    return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function fmtDate(value, withTime = false) {
    if (!value) return '—';
    try {
        return moment(value).format(withTime ? 'YYYY/MM/DD HH:mm' : 'YYYY/MM/DD');
    } catch {
        return '—';
    }
}

function fmtNum(value) {
    if (value == null || value === '') return '0';
    const n = Number(value);
    if (!Number.isFinite(n)) return '0';
    return new Intl.NumberFormat('en-US').format(n);
}

function fmtMoney(value) {
    if (value == null || value === '') return '—';
    const n = Number(value);
    if (!Number.isFinite(n)) return '—';
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(n);
}

function buildHeader(detail) {
    const code = escapeHtml(detail.code || '');
    const typeLabel = escapeHtml(detail.typeLabel || 'سند');
    const branchName = escapeHtml(detail.branchName || '—');
    const date = fmtDate(detail.createdOn || detail.printedOn || detail.date);

    return `
        <div class="doc-header">
            <div class="doc-logo">
                <img src="/assets/img/1/logo.png" alt="logo" />
            </div>
            <div class="doc-title-block">
                <h1 class="doc-title">${typeLabel}</h1>
                <div class="doc-subtitle">وزارة الصحة — منظومة المخزون النهائي</div>
            </div>
            <div class="doc-meta">
                <div><strong>رقم السند:</strong> ${code}</div>
                <div><strong>التاريخ:</strong> ${date}</div>
                <div><strong>المرفق:</strong> ${branchName}</div>
            </div>
        </div>
    `;
}

function buildLinesTable(detail) {
    const lines = detail.lines || [];
    const isInvoice = detail.source === 'invoice' || detail.typeKey === 'invoice';
    const isCount = detail.source === 'inventory_count' || detail.typeKey === 'count';

    if (isInvoice) {
        const rows = lines.map((l, i) => `
            <tr>
                <td>${i + 1}</td>
                <td class="text-end">${escapeHtml(l.productName || '—')}</td>
                <td>${fmtNum(l.quantity)}</td>
                <td>${fmtMoney(l.unitPrice)}</td>
                <td>${fmtMoney(l.total)}</td>
            </tr>
        `).join('');
        return `
            <table class="doc-table">
                <thead>
                    <tr>
                        <th style="width:50px">#</th>
                        <th>الصنف</th>
                        <th style="width:100px">الكمية</th>
                        <th style="width:130px">سعر الوحدة</th>
                        <th style="width:140px">الإجمالي</th>
                    </tr>
                </thead>
                <tbody>${rows || '<tr><td colspan="5" class="text-center">لا توجد أصناف</td></tr>'}</tbody>
            </table>
        `;
    }

    if (isCount) {
        const rows = lines.map((l, i) => `
            <tr>
                <td>${i + 1}</td>
                <td class="text-end">${escapeHtml(l.productName || '—')}</td>
                <td>${escapeHtml(l.batchNumber || '—')}</td>
                <td>${escapeHtml(l.expiryDate ? fmtDate(l.expiryDate) : '—')}</td>
                <td>${fmtNum(l.systemQty)}</td>
                <td>${l.actualQty == null ? '—' : fmtNum(l.actualQty)}</td>
                <td>${fmtNum(l.variance)}</td>
            </tr>
        `).join('');
        return `
            <table class="doc-table">
                <thead>
                    <tr>
                        <th style="width:50px">#</th>
                        <th>الصنف</th>
                        <th style="width:120px">الدفعة</th>
                        <th style="width:120px">الصلاحية</th>
                        <th style="width:100px">رصيد النظام</th>
                        <th style="width:100px">الفعلي</th>
                        <th style="width:100px">الفرق</th>
                    </tr>
                </thead>
                <tbody>${rows || '<tr><td colspan="7" class="text-center">لا توجد أصناف</td></tr>'}</tbody>
            </table>
        `;
    }

    const rows = lines.map((l, i) => `
        <tr>
            <td>${i + 1}</td>
            <td class="text-end">${escapeHtml(l.productName || '—')}</td>
            <td>${escapeHtml(l.batchNumber || '—')}</td>
            <td>${escapeHtml(l.expiryDate ? fmtDate(l.expiryDate) : '—')}</td>
            <td>${fmtNum(l.quantity)}</td>
        </tr>
    `).join('');
    return `
        <table class="doc-table">
            <thead>
                <tr>
                    <th style="width:50px">#</th>
                    <th>الصنف</th>
                    <th style="width:120px">الدفعة</th>
                    <th style="width:120px">الصلاحية</th>
                    <th style="width:100px">الكمية</th>
                </tr>
            </thead>
            <tbody>${rows || '<tr><td colspan="5" class="text-center">لا توجد أصناف</td></tr>'}</tbody>
        </table>
    `;
}

function buildFooter(detail) {
    const showTotal = detail.source === 'invoice' || detail.typeKey === 'invoice';
    const totalsBlock = showTotal
        ? `
            <table class="doc-totals">
                <tr><td>الإجمالي الفرعي</td><td>${fmtMoney(detail.subTotal)}</td></tr>
                <tr><td>الخصم</td><td>${fmtMoney(detail.discount)}</td></tr>
                <tr><td><strong>الإجمالي النهائي</strong></td><td><strong>${fmtMoney(detail.total)}</strong></td></tr>
                <tr><td>المدفوع</td><td>${fmtMoney(detail.paid)}</td></tr>
            </table>
        `
        : '';

    const linesCount = detail.linesCount != null ? detail.linesCount : (detail.lines || []).length;
    const totalQty = detail.totalQty != null ? detail.totalQty : (detail.lines || []).reduce((s, l) => s + (Number(l.quantity) || 0), 0);

    return `
        <div class="doc-summary-row">
            <div class="doc-summary-cell">
                <span>عدد الأصناف</span>
                <strong>${fmtNum(linesCount)}</strong>
            </div>
            <div class="doc-summary-cell">
                <span>إجمالي الكمية</span>
                <strong>${fmtNum(totalQty)}</strong>
            </div>
            ${detail.note
                ? `<div class="doc-summary-cell doc-summary-note"><span>ملاحظات</span><strong>${escapeHtml(detail.note)}</strong></div>`
                : ''}
        </div>
        ${totalsBlock}

        <div class="doc-signatures">
            <div class="doc-sig">
                <p><strong>المُعد</strong><br/>الاسم: .........................<br/>التوقيع: .........................</p>
            </div>
            <div class="doc-sig">
                <p><strong>المراجع</strong><br/>الاسم: .........................<br/>التوقيع: .........................</p>
            </div>
            <div class="doc-sig">
                <p><strong>أمين المخزن / المدير</strong><br/>الاسم: .........................<br/>التوقيع والختم: .........................</p>
            </div>
        </div>

        <div class="doc-footer">
            <p>${escapeHtml(detail.typeLabel || 'سند')} — ${escapeHtml(detail.code || '')} —
               مرجع تلقائي للحفظ والمراجعة. لا يُعتمد إلا بالأختام والتوقيعات الأصلية.</p>
        </div>
    `;
}

export function buildVoucherPrintHtml(detail, options) {
    const opts = options || {};
    const isPdfMode = opts.mode === 'pdf';
    const titlePrefix = isPdfMode ? 'PDF — ' : '';
    const headTitle = `${titlePrefix}${escapeHtml(detail.typeLabel || 'سند')} ${escapeHtml(detail.code || '')}`;

    return `<!doctype html>
<html dir="rtl" lang="ar">
<head>
    <meta charset="utf-8" />
    <title>${headTitle}</title>
    <link href="https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700&display=swap" rel="stylesheet" />
    <style>
        * { box-sizing: border-box; }
        body {
            font-family: 'Cairo', 'Tahoma', sans-serif;
            margin: 0;
            padding: 16mm 12mm;
            background: #fff;
            color: #1f2937;
        }
        .doc-header {
            display: flex;
            align-items: center;
            gap: 12px;
            border-bottom: 2px solid #7367f0;
            padding-bottom: 10px;
            margin-bottom: 14px;
        }
        .doc-logo img { height: 56px; }
        .doc-title-block { flex: 1; }
        .doc-title {
            margin: 0 0 4px;
            font-size: 22px;
            color: #7367f0;
        }
        .doc-subtitle { font-size: 12px; color: #6b7280; }
        .doc-meta {
            font-size: 12px;
            text-align: end;
            line-height: 1.7;
        }
        .doc-table {
            width: 100%;
            border-collapse: collapse;
            margin: 12px 0;
            font-size: 12.5px;
        }
        .doc-table th, .doc-table td {
            border: 1px solid #e5e7eb;
            padding: 6px 8px;
            text-align: center;
        }
        .doc-table th {
            background: #f3f4f6;
            font-weight: 700;
        }
        .doc-table .text-end { text-align: end; }
        .doc-table .text-center { text-align: center; }

        .doc-summary-row {
            display: flex;
            gap: 12px;
            margin: 14px 0 10px;
            flex-wrap: wrap;
        }
        .doc-summary-cell {
            flex: 1 1 160px;
            background: #f9fafb;
            border: 1px solid #e5e7eb;
            border-radius: 6px;
            padding: 8px 10px;
        }
        .doc-summary-cell span { font-size: 11px; color: #6b7280; }
        .doc-summary-cell strong { display: block; font-size: 14px; margin-top: 2px; }
        .doc-summary-cell.doc-summary-note { flex: 1 1 100%; }

        .doc-totals {
            width: 320px;
            margin-inline-start: auto;
            margin-top: 6px;
            border-collapse: collapse;
            font-size: 13px;
        }
        .doc-totals td {
            border: 1px solid #e5e7eb;
            padding: 6px 10px;
        }
        .doc-totals td:last-child { text-align: end; }

        .doc-signatures {
            display: flex;
            gap: 18px;
            margin-top: 22px;
        }
        .doc-sig {
            flex: 1 1 33%;
            border: 1px dashed #d1d5db;
            border-radius: 6px;
            padding: 10px 12px;
            font-size: 12px;
            line-height: 1.7;
        }

        .doc-footer {
            margin-top: 16px;
            padding-top: 8px;
            border-top: 1px solid #e5e7eb;
            font-size: 11px;
            color: #6b7280;
            text-align: center;
        }

        @media print {
            body { padding: 8mm 8mm; }
            @page { size: A4; margin: 8mm; }
        }
    </style>
</head>
<body>
    ${buildHeader(detail)}
    ${buildLinesTable(detail)}
    ${buildFooter(detail)}
    <script>
        window.onload = function() {
            try {
                window.focus();
                setTimeout(function() { window.print(); }, 350);
            } catch (e) { /* noop */ }
        };
    </script>
</body>
</html>`;
}

export function openPrintWindow(html, asPdfHint) {
    const w = window.open('', '_blank', 'width=900,height=700');
    if (!w) {
        return false;
    }
    try {
        w.document.open();
        w.document.write(html);
        w.document.close();
        if (asPdfHint) {
            try {
                w.document.title = 'احفظ السند كـ PDF';
            } catch (e) { /* noop */ }
        }
    } catch (e) {
        try { w.close(); } catch (ee) { /* noop */ }
        return false;
    }
    return true;
}
